import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from './pages/Dashboard.vue';
import Login from './pages/Login.vue';

Vue.use(Router);


const routes = [{
	path: '/',
	name: 'dashboard',
	component: Dashboard,
	meta: {
		requiresAuth: true
	}
}, {
	path: '/login',
	name: 'login',
	component: Login,
	meta: {
		guest: true
	}
}, {
	path: `/list/:module`,
	component: () => import(`./pages/Crud/Index.vue`),
	meta: {
		requiresAuth: true
	}
}, {
	path: `/edit/:module/:id`,
	component: () => import(`./pages/Crud/Edit.vue`),
	meta: {
		requiresAuth: true
	}
}, {
	path: `/create/:module`,
	component: () => import(`./pages/Crud/Create.vue`),
	meta: {
		requiresAuth: true
	}
}, {
	path: '/module/list',
	component: () => import(`./pages/Module/Index.vue`),
	meta: {
		requiresAuth: true
	}
}, {
	path: '/module/edit/:id',
	component: () => import(`./pages/Module/Edit.vue`),
	meta: {
		requiresAuth: true
	}
}, {
	path: '/enum/list',
	component: () => import(`./pages/Enum/Index.vue`),
	meta: {
		requiresAuth: true
	}
}, {
	path: '/enum/edit/:id',
	component: () => import(`./pages/Enum/Edit.vue`),
	meta: {
		requiresAuth: true
	}
},
{
	path: '/Comment/List',
	component: () => import(`./pages/Comment/Index.vue`),
	meta: {
		requiresAuth: true
	}
}
];

let router =
	new Router({
		routes: routes,
		scrollBehavior() {
			return { x: 0, y: 0 };
		}
	});


router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.requiresAuth)) {
		if (localStorage.getItem('jwt') == null) {
			next({
				path: '/login',
				params: { nextUrl: to.fullPath }
			})
		} else {
			//let user = JSON.parse(localStorage.getItem('user'))
			next()
		}
	} else if (to.matched.some(record => record.meta.guest)) {
		if (localStorage.getItem('jwt') == null) {
			next()
		}
		else {
			next({ name: 'dashboard' })
		}
	} else {
		next()
	}
})


export default router;